

import { useState, useRef } from 'react';
import {
    Badge,
    ButtonGroup,
    Col,
    Container,
    Image,
    Row,
    Stack
} from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import { Modal } from "react-bootstrap";
import PickUpInStore from '../../component/PickUpInStore';
import SuggestedProducts from '../../component/SuggestedProducts';
import { Button, Dimmer, Grid, Icon, Label, Loader, Popup, Header, Breadcrumb, BreadcrumbDivider, BreadcrumbSection } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStore } from '@fortawesome/free-solid-svg-icons'
import 'semantic-ui-css/semantic.min.css';
import { useEffect } from 'react';
import axios from 'axios';
import { useMyGlobal } from '../../component/GlobalData';
import { formatNumberWithCommas, slugify } from '../../component/utility';
import { Toast } from '../../component/Toast';
import { Helmet } from 'react-helmet';
import logoHoops from '../../assets/logo_hoops_opa.png';
import { useGesture } from '@use-gesture/react';
import { useSpring, animated } from '@react-spring/web';
import SeoHelmet from '../../component/SeoHelmet';

const ProductPage = ({ pickedProduct }) => {
    const navigate = useNavigate()
    const products = useLocation().state;
    const [dataPage, setDataPage] = useState(null)
    const [laoderProduct, setLoaderProduct] = useState(false)
    const [selectedSize, setSelectedSize] = useState(null)
    const [selectedBarcodePickUp, setSelectedBarcodePickUp] = useState(null)
    const [selectedSizePickUp, setSelectedSizePickUp] = useState(null)
    const [selectedWarehouse, setSelectedWarehouse] = useState(null)
    const [selectedColorId, setSelectedColorId] = useState(null)
    const [selectedColor, setSelectedColor] = useState(null)
    const [activeSize, setActiveSize] = useState(null)
    const ses = localStorage
    const [sortDataSize, setSortDataSize] = useState([])
    const [sortDataSizeGroup, setSortDataSizeGroup] = useState([])
    const [mssgTxt, setMsgTxt] = useState('')
    const [excludeID, setExcludeID] = useState('')
    const [pickCategory, setPickCategory] = useState('')

    const [defaultImage, setDefaultImage] = useState()
    const [productImage, setProductImage] = useState([])
    const [productDiscount, setProductDiscount] = useState()
    const [multipleDiscLabel, setMultipleDiscLabel] = useState(dataPage?.multiple_disc_label ?? "")
    const [discountType, setDiscountType] = useState()
    const [productDiscountNominal, setProductDiscountNominal] = useState()
    const [productDiscountText, setProductDiscountText] = useState('')
    const [discountTotal, setDiscountTotal] = useState()
    const [isOrdered, setIsOrdered] = useState(null)
    const [isPickUp, setIsPickUp] = useState(null)
    const idCustomer = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')).id : null
    const [wish, setWish] = useState(null)
    const [sizeQty, setSizeQty] = useState('')
    const { token, idCart } = useMyGlobal()
    const { isPortrait, windowWidth } = useMyGlobal()
    const [login, setLogin] = useState(null)
    const [coLoad, setCoLoad] = useState(false)
    const [atcLoad, setAtcLoad] = useState(false)
    const [pickUpLoader, setPickUpLoader] = useState(false)
    const [modalPickUp, setModalPickUp] = useState(false)
    const [isValidMobile, setIsValidMobile] = useState(false)
    const [hasSizeObject, setHasSizeObject] = useState({})
    const { productId, productDesc } = useParams()
    
    const [metaTitle, setMetaTitle] = useState('')
    const [metaDescription, setMetaDescription] = useState('')

    const percentTag = {
        alignItems: 'center',
        background: 'linear-gradient(to right, #cc3b21, #FFA500)',
        fontSize: '0.714286rem',
        color: 'rgb(255, 255, 255)',
        fontWeight: 600,
        fontSize: '0.714286rem',
        borderRadius: '0 0 5px 0px',
    }

    const percentTagNormal = {
        alignItems: 'center',
        background: 'linear-gradient(to right, grey, lightgrey)',
        fontSize: '0.714286rem',
        color: 'rgb(255, 255, 255)',
        fontWeight: 600,
        fontSize: '0.714286rem',
        borderRadius: '0 0 5px 0px',
    }

    const bodyStyle = {
        backgroundImage: `url(${logoHoops})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    }

    const getPickUpWidthStyle = () => {
        if (windowWidth < 768) return '100%';
        if (windowWidth >= 768 && windowWidth < 992) return '115%';
        if (windowWidth < 1200) return '73%';
        if (windowWidth < 1400) return '61%';
        return '53%';
    };

    const hasPercentDiscount = productDiscount > 0;
    const hasNominalDiscount = productDiscountNominal > 0;
    const hasMultipleDisc = dataPage?.multiple_disc_label !== "" && dataPage?.multiple_disc_label !== null && dataPage?.multiple_disc_label !== undefined;

    const discountLabel = () => {
        const labels = [];

        if (hasPercentDiscount) {
            labels.push(
                <Label key="percent" size="small" style={percentTag}>
                    {productDiscountText
                        ? productDiscountText
                        : discountType === "nominal"
                            ? global.IDR.format(productDiscount)
                            : `${Math.ceil(productDiscount)}%`}
                </Label>
            );
        }

        if (!hasPercentDiscount && hasNominalDiscount) {
            labels.push(
                <Label key="nominal" size="small" style={percentTag}>
                    {productDiscountText
                        ? productDiscountText
                        : global.IDR.format(productDiscountNominal)}
                </Label>
            );
        }

        if (hasMultipleDisc) {
            labels.push(
                <Label key="multiple" size="small" style={percentTag}>
                    Multiple Disc. {dataPage?.multiple_disc_label}
                </Label>
            );
        }

        if (labels.length === 0) {
            return (
                <Popup
                    content="Normal Price"
                    size="mini"
                    trigger={
                        <span>
                            <Label size="small" style={percentTagNormal}>
                                No Dscn.
                            </Label>
                        </span>
                    }
                />
            );
        }

        return <>{labels}</>;
    };

    useEffect(() => {
        if (!dataPage) return;
        setExcludeID(dataPage.id_product);
        setPickCategory(dataPage.id_category);
    }, [dataPage]);

    const closeModalPickUp = () => (setModalPickUp(false))
    const showModalPickUp = () => (setModalPickUp(true))

    const setProductDetail = (dataProduct) => {
        setDefaultImage(dataProduct.image.length > 0 ? dataProduct.image.filter(i => i.is_default == 1).map(i => i.image) : 'https://via.placeholder.com/500x400.png')
        setProductImage(dataProduct.image.map(i => i.image))
        // setdataProductDiscount((dataProduct.discount) ? dataProduct.discount.discount_value : 0)
        setDiscountTotal((dataProduct.discount) ? dataProduct.discount.discount_total : 0)

        const handleProductDsc = () => {
            if (dataProduct.isDiscounted === '1' && dataProduct.fs_on) {
                setProductDiscount(dataProduct.fs_discount)
                setProductDiscountText(dataProduct.fs_text)
            } else if (dataProduct.isDiscounted === '1' && !dataProduct.fs_on) {
                setProductDiscount(dataProduct.discount.discount_value)
                setProductDiscountText(dataProduct.discount.discount_text)
                setDiscountType(dataProduct.discount.discount_type)
            } else if (dataProduct.isDiscounted === '0' && dataProduct.fs_on) {
                setProductDiscount(dataProduct.fs_discount)
                setProductDiscountText(dataProduct.fs_text)
            } else if (dataProduct.isDiscounted === '0' && !dataProduct.fs_on) {
                setProductDiscount(0)
            }
        }

        const handleProductDscNominal = () => {
            if (dataProduct.isDiscounted === '1' && dataProduct.fs_on) {
                setProductDiscountNominal(dataProduct.fs_nominal)
            } else if (dataProduct.isDiscounted === '0' && dataProduct.fs_on) {
                setProductDiscountNominal(dataProduct.fs_nominal)
            } else {
                setProductDiscountNominal(0)
            }
        }

        const handleDiscountTotal = () => {
            if (dataProduct.isDiscounted === '1' && dataProduct.fs_on) {
                setDiscountTotal(dataProduct.fs_discount_value)
            } else if (dataProduct.isDiscounted === '1' && !dataProduct.fs_on) {
                setDiscountTotal(dataProduct.discount.discount_total)
            } else if (dataProduct.isDiscounted === '0' && dataProduct.fs_on) {
                setDiscountTotal(dataProduct.fs_discount_value)
            } else if (dataProduct.isDiscounted === '0' && !dataProduct.fs_on) {
                setDiscountTotal(0)
            }
        }

        handleProductDsc()
        handleProductDscNominal()
        handleDiscountTotal()
    }


    const handleClickSize = (size) => {
        setSelectedSize(size)
        if (dataPage.qty > 0) {
            setSizeQty(dataPage.barcode.filter(o => o.size == size)[0].qty)
        } else {
            setSizeQty(0)
        }
    }

    const handleClickWishlist = (id_customer, id_product, id_category) => {
        const param = new URLSearchParams()
        param.append('id_customer', id_customer)
        param.append('id_product', id_product)
        param.append('id_category', id_category)
        axios({
            method: "POST",
            url: `${process.env.REACT_APP_ERP_URL}api_web/controler/product${global.APPSUFFIX}.php?index=6`,
            // url: "https://hoopsindonesia.co.id/api_hoops/controler/product.php?index=6",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        }).
            then(response => {
                if (response.data.state === 200) {
                    setWish(true)
                    Toast.fire({
                        icon: "success",
                        text: "Wishlist updated",
                        position: "top-end",
                    })
                } else {
                    Toast.fire({
                        icon: "warning",
                        text: response.data.message,
                        position: "top-end",
                    })
                }
            })
    }

    // const getIsWish = async (id_customer, id_product) => {
    //     const param = new URLSearchParams()
    //     param.append('id_customer', id_customer)
    //     param.append('id_product', id_product)

    //     await axios({
    //         method: "POST",
    //         url: "https://hoopsdevteam.com/api_web/controler/product.php?index=7", // OVER REQUEST
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded',
    //             'Authorization': token
    //         },
    //         data: param
    //     })
    //         .then(response => {
    //             console.log(response.data)
    //             if (response.data.state === 200) {
    //                 (response.data.exist === 1) ? setWish(true) : setWish(false)
    //             }
    //         })
    // }

    const addProductCart = (from) => {
        let cartData = JSON.parse(localStorage.getItem('loginData'))
        if (!cartData.hasOwnProperty('id_cart') && cartData.id_cart != 'undefined') {
            alert("Please try to logout & login again, after that you can add items to your basket, but don't worry this only happens when you first register")
        } else {
            from == 'co' ? setCoLoad(true) : from == 'pickUp' ? setPickUpLoader(true) : setAtcLoad(true)
            const param = new URLSearchParams()
            param.append('id_customer', login.id)
            param.append('isPickUp', from == 'pickUp' ? selectedWarehouse : '0')
            param.append('id_cart', JSON.parse(localStorage.getItem('loginData')).id_cart)
            param.append('id_product', dataPage.id_product)
            param.append('id_color', selectedColor.id_color)
            param.append('size', selectedSizePickUp !== null ? selectedSizePickUp : selectedSize)
            param.append('id_warehouse', selectedWarehouse !== null ? selectedWarehouse : null)
            param.append('qty', 1)
            param.append('barcode', selectedBarcodePickUp !== null ? selectedBarcodePickUp : dataPage.barcode.filter(i => i.size === selectedSize)[0]['barcode'])
            param.append('is_fs', dataPage.fs_on)
            param.append('final_price', dataPage.final_price)

            axios({
                method: "POST",
                url: `${process.env.REACT_APP_SRV_API_URL}controler/cart.php/?index=2`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            }).then(res => {
                if (from == 'co') {
                    setCoLoad(false)
                    navigate('/cart')
                } else if (from == 'pickUp') {
                    setPickUpLoader(false)
                    closeModalPickUp()
                } else {
                    setAtcLoad(false)
                }
                const selected = selectedSizePickUp !== null ? selectedSizePickUp : selectedSize;
                setHasSizeObject(prev => ({
                    ...prev,
                    selected: [...(prev.selected || []), selected]
                }));
                clearPickSize()
            }
            )
        }
    }

    const clearPickSize = () => {
        setSelectedSize(null)
        setSelectedBarcodePickUp(null)
        setSelectedSizePickUp(null)
    }

    useEffect(() => {
        console.log(hasSizeObject.selected)
    }, [hasSizeObject]);

    const updatePickUp = (isPickUp = true) => {
        let cartData = JSON.parse(localStorage.getItem('loginData'))
        if (!cartData.hasOwnProperty('id_cart') && cartData.id_cart != 'undefined') {
            alert("Please try to logout & login again, after that you can add items to your basket, but don't worry this only happens when you first register")
        } else {
            const param = new URLSearchParams()
            param.append('id_customer', login.id)
            if (isPickUp) {
                param.append('id_warehouse', selectedWarehouse)
            } else {
                param.append('id_warehouse', '0')
            }

            axios({
                method: "POST",
                url: `${process.env.REACT_APP_SRV_API_URL}controler/cart.php/?index=26`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            }).then(res => {
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            })
        }
    }

    // const slcProduct = (color, slcSize) => {
    //     return {
    //         'id_warehouse': dataPage.id_warehouse,
    //         'product_id': dataPage.id_product,
    //         'product_name': dataPage.product_name,
    //         'product_desc': dataPage.product_desc,
    //         'product_dimension': dataPage.dimension,
    //         'product_image': dataPage.image.filter(i => i.is_default == 1)[0],
    //         'price': dataPage.price,
    //         'is_discounted': dataPage.isDiscounted,
    //         'id_discount': dataPage.id_discount,
    //         'id_gender': dataPage.id_gender,
    //         'gender_name': dataPage.gender_name,
    //         'id_segment': dataPage.id_segment,
    //         'segment_name': dataPage.segment_name,
    //         'discount': dataPage.discount,
    //         'final_price': dataPage.final_price,
    //         'point': dataPage.point,
    //         'selected_color': color,
    //         'selected_size': slcSize,
    //         'qty': 1,
    //         'barcode': dataPage.barcode.filter(i => i.size === selectedSize)[0]['barcode'],
    //         'flashsale': dataPage.hasOwnProperty('flashsale') ? (dataPage.flashsale.length > 0 ? dataPage.flashsale : []) : [],
    //         "fs_discount": (dataPage.hasOwnProperty('fs_discount')) ? dataPage.fs_discount : 0,
    //         "fs_percent": (dataPage.hasOwnProperty('fs_percent')) ? dataPage.fs_percent : 0,
    //         "fs_on": dataPage.discount_flag === 'FS' ? true : false,
    //     }
    // }

    const slcProduct = (color, slcSize, idWarehouse = null, barcode = null) => {
        return {
            // 'id_warehouse': dataPage.id_warehouse,
            'id_warehouse': idWarehouse == null ? dataPage.id_warehouse : idWarehouse,
            'product_id': dataPage.id_product,
            'product_name': dataPage.product_name,
            'product_desc': dataPage.product_desc,
            'product_dimension': dataPage.dimension,
            'product_image': dataPage.image.filter(i => i.is_default == 1)[0],
            'price': dataPage.price,
            'is_discounted': dataPage.isDiscounted,
            'id_discount': dataPage.id_discount,
            'id_gender': dataPage.id_gender,
            'gender_name': dataPage.gender_name,
            'id_segment': dataPage.id_segment,
            'segment_name': dataPage.segment_name,
            'discount': dataPage.discount,
            'final_price': dataPage.final_price,
            'point': dataPage.point,
            'selected_color': color,
            'selected_size': slcSize,
            'qty': 1,
            // 'barcode': dataPage.barcode.filter(i => i.size === selectedSize)[0]['barcode'],
            'barcode': barcode == null ? dataPage.barcode.filter(i => i.size === selectedSize)[0]['barcode'] : barcode,
            'flashsale': dataPage.hasOwnProperty('flashsale') ? (dataPage.flashsale.length > 0 ? dataPage.flashsale : []) : [],
            "fs_discount": (dataPage.hasOwnProperty('fs_discount')) ? dataPage.fs_discount : 0,
            "fs_percent": (dataPage.hasOwnProperty('fs_percent')) ? dataPage.fs_percent : 0,
            "fs_on": dataPage.discount_flag === 'FS' ? true : false,
        }
    }

    const ImageChild = ({ src }) => {
        return src.map((item, i) => (
            <Col md={3} sm={3} xs={3} onClick={() => setDefaultImage(item)} key={i} className="mb-4">
                <Image src={item} fluid rounded style={{ cursor: 'pointer' }} />
            </Col>
        ))
    }

    const ImageMain = ({ src }) => {
        const imageRef = useRef(null);
        const containerRef = useRef(null);

        // React Spring animated values
        const [{ scale, x, y, originX, originY }, api] = useSpring(() => ({
            scale: 1,
            x: 0,
            y: 0,
            originX: '50%',
            originY: '50%',
            config: { tension: 300, friction: 30 },
        }));

        // Mouse move for desktop
        const handleMouseMove = (e) => {
            const rect = containerRef.current.getBoundingClientRect();
            const offsetX = ((e.clientX - rect.left) / rect.width) * 100;
            const offsetY = ((e.clientY - rect.top) / rect.height) * 100;

            api.start({
                scale: 2,
                originX: `${offsetX}%`,
                originY: `${offsetY}%`,
            });
        };

        const handleMouseLeave = () => {
            api.start({ scale: 1 });
        };

        // Touch gestures using @use-gesture/react
        useGesture(
            {
                onPinch: ({ offset: [d] }) => {
                    api.start({ scale: d / 100 });
                },
                onDrag: ({ offset: [dx, dy] }) => {
                    api.start({ x: dx, y: dy });
                },
                onPinchEnd: () => {
                    if (scale.get() <= 1.1) {
                        api.start({ scale: 1, x: 0, y: 0 });
                    }
                },
                onDragEnd: () => {
                    if (scale.get() <= 1.1) {
                        api.start({ x: 0, y: 0 });
                    }
                },
            },
            {
                target: containerRef,
                pinch: { scaleBounds: { min: 1, max: 4 }, rubberband: true },
                drag: { from: () => [x.get(), y.get()], rubberband: true },
            }
        );

        return (
            <Col sm={12} md={12}>
                {/* <div
                    className="zoom-container"
                    ref={containerRef}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                > */}
                {/* <Image ref={imageRef} className="zoom-image" src={src} fluid rounded /> */}
                {/* </div> */}
                <div
                    className="zoom-container"
                    ref={containerRef}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                >
                    <animated.img
                        ref={imageRef}
                        src={src}
                        alt="Zoomable"
                        className="zoom-image"
                        style={{
                            scale,
                            x,
                            y,
                            transformOrigin: originX.to((ox) => `${ox} ${originY.get()}`),
                        }}
                    />
                </div>
            </Col>
        )
    }

    const previousPriceCoret = (data) => {
        if (data?.isDiscounted == 1 && parseInt(data?.discount.discount_value) > 0) {
            return (<s>{global.IDR.format(data?.price)}</s>)
        } else if ((data?.hasOwnProperty('flashsale') || data?.fs_percent > 0) && data?.isDiscounted == '1' || data?.fs_on) {
            return (<s>{global.IDR.format(data.price)}</s>)
        } else if (data?.isDiscounted == 1 && parseInt(data?.discount.discount_value) === 0) {
            return ''
        }
    }

    useEffect(() => {
        cartState()
        checkPhoneNumber()
    }, [idCustomer])

    const cartState = async () => {
        const param = new URLSearchParams()
        param.append('id_customer', idCustomer)
        await axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/cart.php/?index=9`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then(response => {
                if (response.data.state == 200) {
                    // setIsOrdered(response.data.data)
                    setIsOrdered(response.data.data.isOrdered)
                    setIsPickUp(response.data.data.isPickUp)
                }
            })
    }

    const checkPhoneNumber = async () => {
        const param = new URLSearchParams()
        param.append('id_customer', idCustomer)
        await axios({
            method: "POST",
            url: `${process.env.REACT_APP_SRV_API_URL}controler/customer.php/?index=15`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then(response => {
                if (response.data.state == 200) {
                    setIsValidMobile(response.data.data)
                }
            })
    }

    const handleRouteToCat = (cat) => {
        const slug = slugify(cat.name)
        navigate(`/product_list/${cat.child_id}/${slug}`)
    }

    useEffect(() => {
        if (products) {
            document.title = products.product_name + " | Hoops Indonesia"
        } else if (dataPage) {
            document.title = dataPage.product_name + " | Hoops Indonesia"
        }
        
        const meta = document.querySelector(
            'meta[name="description"]'
        );

        if (meta) {
            meta.setAttribute(
            "content",
            metaDescription
            );
        }
        /*
        if (products) {
            if (metaTitle == '' || metaTitle == null){
                document.title = products.product_name + " | Hoops Indonesia"
            } else {
                document.title = metaTitle.includes(' | Hoops Indonesia')
                                ? metaTitle
                                : `${metaTitle} | Hoops Indonesia`
            }
        } else if (dataPage) {
            if (metaTitle == '' || metaTitle == null){
                document.title = dataPage.product_name + " | Hoops Indonesia"
            } else {
                document.title = metaTitle.includes(' | Hoops Indonesia')
                                ? metaTitle
                                : `${metaTitle} | Hoops Indonesia`
            }
        }
        */
    }, [products, dataPage])

    useEffect(() => {
        const param = new FormData()
        // let url = window.location.href
        // let urlSegments = url.split('/');
        // let id_product = decodeURIComponent(urlSegments[urlSegments.length - 1]);
        // let uri = new URL(window.location.href);
        // let id_product = uri.pathname.split('/').pop();

        const getProductData = async (idProduct) => {
            setLoaderProduct(true)
            param.append('id_product', idProduct)
            param.append('id_cart', idCart)
            if (idCustomer) {
                param.append('id_customer', idCustomer)
            } else {
                param.append('id_customer', '')
            }
            await axios({
                method: "POST",
                url: `${process.env.REACT_APP_ERP_URL}api_web/controler/product${global.APPSUFFIX}.php?index=16`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
                data: param
            })
                .then(resProd => {
                    let data = resProd.data.data[0]
                    if (resProd.data.data.length > 0) {
                        /*
                        const groupedData = []

                        if (data.size_list == '') {
                            const numericSizes = data.barcode.filter(item => !isNaN(parseFloat(item.size)));
                            const nonNumericSizes = data.barcode.filter(item => isNaN(parseFloat(item.size)));
                            if (numericSizes.length > 0) {
                                const size = data.barcode.sort((a, b) => parseFloat(a.size) - parseFloat(b.size))
                                for (let i = 0; i < size.length; i += 6) {
                                    groupedData.push(size.slice(i, i + 6));
                                }
                                setSortDataSizeGroup(groupedData)
                                setSortDataSize(size)
                            } else if (nonNumericSizes.length > 0) {
                                const sortNonNumeric = (a, b) => {
                                    const sizeOrder = { "S": 1, "M": 2, "L": 3, "XL": 4, "XXL": 5 };
                                    return sizeOrder[a.size] - sizeOrder[b.size];
                                }
                                const size = data.barcode.sort(sortNonNumeric)
                                for (let i = 0; i < size.length; i += 6) {
                                    groupedData.push(size.slice(i, i + 6));
                                }
                                setSortDataSizeGroup(groupedData)
                                setSortDataSize(size)
                            }
                        } else {
                            const mergedSize = data.size_list.map(sizeName => {

                                // cari barcode yg cocok
                                const found = data.barcode.find(
                                    item => item.size === sizeName
                                )

                                // kalau ada barcode -> pakai data asli
                                // kalau gak ada -> bikin dummy disabled
                                return found || {
                                    barcode: null,
                                    size: sizeName,
                                    qty: 0,
                                    has_item: false
                                }
                            })

                            // grouping per 6 item
                            for (let i = 0; i < mergedSize.length; i += 6) {
                                groupedData.push(mergedSize.slice(i, i + 6));
                            }

                            setSortDataSizeGroup(groupedData)
                            setSortDataSize(mergedSize)
                        }
                        */

                        const groupedData = []

                        const hasValidSizeList =
                            Array.isArray(data.size_list) &&
                            data.size_list.length > 0 &&
                            data.size_list.some(sizeName =>
                                data.barcode.some(
                                    item =>
                                        item.size?.toString().trim().toUpperCase()
                                        ===
                                        sizeName?.toString().trim().toUpperCase()
                                )
                            )

                        if (!hasValidSizeList) {

                            const numericSizes = data.barcode.filter(
                                item => !isNaN(parseFloat(item.size))
                            );

                            const nonNumericSizes = data.barcode.filter(
                                item => isNaN(parseFloat(item.size))
                            );

                            if (numericSizes.length > 0) {

                                const size = data.barcode.sort(
                                    (a, b) => parseFloat(a.size) - parseFloat(b.size)
                                )

                                for (let i = 0; i < size.length; i += 6) {
                                    groupedData.push(size.slice(i, i + 6));
                                }

                                setSortDataSizeGroup(groupedData)
                                setSortDataSize(size)

                            } else if (nonNumericSizes.length > 0) {

                                const sortNonNumeric = (a, b) => {

                                    const sizeOrder = {
                                        "S": 1,
                                        "M": 2,
                                        "L": 3,
                                        "XL": 4,
                                        "XXL": 5
                                    };

                                    return sizeOrder[a.size] - sizeOrder[b.size];
                                }

                                const size = data.barcode.sort(sortNonNumeric)

                                for (let i = 0; i < size.length; i += 6) {
                                    groupedData.push(size.slice(i, i + 6));
                                }

                                setSortDataSizeGroup(groupedData)
                                setSortDataSize(size)
                            }

                        } else {

                            const mergedSize = data.size_list.map(sizeName => {

                                const found = data.barcode.find(
                                    item =>
                                        item.size?.toString().trim().toUpperCase()
                                        ===
                                        sizeName?.toString().trim().toUpperCase()
                                )

                                return found || {
                                    barcode: null,
                                    size: sizeName,
                                    qty: 0,
                                    has_item: false
                                }
                            })

                            for (let i = 0; i < mergedSize.length; i += 6) {
                                groupedData.push(mergedSize.slice(i, i + 6));
                            }

                            setSortDataSizeGroup(groupedData)
                            setSortDataSize(mergedSize)
                        }

                        

                        if (!data.hasOwnProperty('included_on_voucher')) {
                            const getVoucherProduct = async () => {
                                await axios({
                                    method: "GET",
                                    url: `${process.env.REACT_APP_SRV_API_URL}controler/voucher.php?index=3`,
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded',
                                        'Authorization': token
                                    },
                                })
                                    .then(res => {
                                        if (res.data.state === 200) {
                                            let voucherTemp = []
                                            res.data.data.forEach(i => {
                                                if (data.id_product == i.id_product) {
                                                    voucherTemp.push(i)
                                                }
                                            })
                                            data.included_on_voucher = voucherTemp
                                            setDataPage(data)
                                            setLoaderProduct(false)

                                        }
                                    })
                            }
                            getVoucherProduct()
                        }

                        setProductDetail(data)
                        setLogin(JSON.parse(ses.getItem('loginData')))
                        window.scrollTo(0, 0)
                        if (data.color.length == 1) {
                            setSelectedColor(data.color[0])
                        }
                        setLoaderProduct(false)
                        if (data.meta_description == '' || data.meta_description == null){
                            setMetaDescription("Beli " + data.product_name + " original di Hoops Indonesia. Stok terbatas.")
                        } else {
                            setMetaDescription(data.meta_description)
                        }
                        
                        setMetaTitle(products.product_name)
                        /*
                        if (data.meta_title == '' || data.meta_title == null){
                            setMetaTitle(data.product_name + " | Hoops Indonesia")
                        } else {
                            setMetaTitle(data.meta_title)
                        }
                        */
                        
                        //console.log("Meta Title : " + data.meta_title )
                        //console.log("Meta Description : " + data.meta_description)
                    } else {
                        setLoaderProduct(false)
                        setMsgTxt('Product Not Found')
                    }
                }).finally(() => {
                    setSelectedSize(null)
                })
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
        getProductData(productId)
    }, [productId])

    return (
        <>
            {/*
            <SeoHelmet
                title={metaTitle}
                description={metaDescription}
            />
            */}
        
            <Dimmer active={laoderProduct}>
                <Loader inverted>Loading Product...</Loader>
            </Dimmer>
            {
                dataPage ?
                    <Container className='mt-5 mb-5 page-padding-top' fluid='sm' style={{ minHeight: '90vh', height: '100%' }}>
                        <Modal size='lg' show={modalPickUp} backdrop='static' keyboard={false} onHide={closeModalPickUp} centered>
                            <Modal.Header closeButton={!pickUpLoader}>
                                <span className="fs-5">Pick Up in Store</span>
                            </Modal.Header>
                            <Modal.Body style={windowWidth >= 992 ? { minHeight: '80vh', overflowY: 'hidden' } : {}}>
                                <Row>
                                    <Col xs={12} lg={2}>
                                        <Header as="h4" className='text-center mb-3'>
                                            Choose your size! {windowWidth < 992 ? (dataPage?.size_group) ? `Size Group: ${dataPage?.size_group}` : "Size Group: Not Set" : ''}
                                        </Header>
                                    </Col>
                                    <Col md={12} xs={12}>
                                        <PickUpInStore
                                            defaultWarehouse={isPickUp}
                                            idProduct={dataPage?.id_product}
                                            data={dataPage?.barcode_pick_up}
                                            pickUpLoader={pickUpLoader}
                                            setSelectedColorId={setSelectedColorId}
                                            setSelectedWarehouse={setSelectedWarehouse}
                                            setSelectedSizePickUp={setSelectedSizePickUp}
                                            setSelectedBarcodePickUp={setSelectedBarcodePickUp}
                                        />
                                    </Col>
                                    {windowWidth >= 992 && (
                                        <Col lg={2}>
                                            <Header as="h4" className='text-center mb-3'>
                                                Size Group: <br />{(dataPage?.size_group) ? dataPage?.size_group : "Not Set"}
                                            </Header>
                                        </Col>
                                    )}
                                </Row>
                            </Modal.Body>
                            <Modal.Footer className='d-flex justify-content-between mt-2'>
                                <Button content="Size Guide" color='black' icon="external alternate" basic size='tiny' labelPosition='right' onClick={() => navigate('/home/sizeGuide')} />
                                <Button
                                    onClick={() => {
                                        // if (isPickUp == 0) {
                                        //     Toast.fire({
                                        //         icon: 'warning',
                                        //         text: 'Your cart has been set as Delivery Order. Please remove all item in cart first then try again!',
                                        //         position: 'center'
                                        //     })
                                        // } else {
                                        //     pickedProduct(slcProduct(selectedColor, selectedSizePickUp, selectedWarehouse, selectedBarcodePickUp));
                                        //     addProductCart('pickUp')
                                        //     setIsPickUp("1")
                                        // }

                                        if (ses.getItem('loginData')) {
                                            const pickSize = selectedSizePickUp !== null ? selectedSizePickUp : selectedSize
                                            const match = sortDataSize.find(item => item.size === pickSize);
                                            const hasItem = match ? match.has_item : false;
                                            const hasSizeClick = Array.isArray(hasSizeObject.selected) && hasSizeObject.selected.includes(pickSize)
                                            if (isOrdered == 0 && isOrdered !== null) {
                                                if (isPickUp == 0) {
                                                    Toast.fire({
                                                        //timer: 6000,
                                                        icon: 'warning',
                                                        text: 'Your cart has been set as Delivery Order. Please remove all item in cart first then try again!',
                                                        position: 'center',
                                                        showCloseButton: true
                                                    })
                                                } else if (hasItem || hasSizeClick) {
                                                    Toast.fire({
                                                        ////timer: 6000,
                                                        icon: 'warning',
                                                        text: 'The size that you pick is already set in your cart. Please pick other size!',
                                                        position: 'center',
                                                        showCloseButton: true
                                                    })
                                                } else if (!isValidMobile) {
                                                    Swal.fire({
                                                        icon: 'warning',
                                                        title: 'Missing Phone Number',
                                                        text: 'You have to add a phone number in the address form!',
                                                        position: 'center',
                                                        allowOutsideClick: false,
                                                        allowEscapeKey: false,
                                                        showConfirmButton: true,
                                                        confirmButtonText: 'Go to Profile',
                                                        showCancelButton: true,
                                                        cancelButtonText: 'Close',
                                                        reverseButtons: true,
                                                        customClass: {
                                                            // popup: 'swal2-toast',
                                                            confirmButton: 'ui orange button',
                                                            cancelButton: 'ui button'
                                                        },
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            window.location.href = '/customer/profile';
                                                        }
                                                    });

                                                } else {
                                                    pickedProduct(slcProduct(selectedColor, selectedSizePickUp, selectedWarehouse, selectedBarcodePickUp));
                                                    addProductCart('pickUp')
                                                    setIsPickUp(selectedWarehouse)
                                                    if (isPickUp === null) {
                                                        updatePickUp(true)
                                                    }
                                                }
                                            } else if (isOrdered == 1) {
                                                Toast.fire({
                                                    icon: 'warning',
                                                    text: 'There`s pending Order',
                                                    position: 'center',
                                                    showCloseButton: true,
                                                })
                                                navigate('/cart/checkout')
                                            } else if (isOrdered == 2) {
                                                Toast.fire({
                                                    icon: 'warning',
                                                    text: 'There`s pending Payment',
                                                    position: 'center',
                                                    showCloseButton: true,
                                                })
                                                navigate('/cart/checkout/payment')
                                            } else if (isOrdered == 3) {
                                                Toast.fire({
                                                    icon: 'warning',
                                                    text: 'There`s pending Payment',
                                                    position: 'center',
                                                    showCloseButton: true,
                                                })
                                                navigate('/cart/checkout/paymentSnap')
                                            }
                                        } else {
                                            Toast.fire({
                                                icon: "warning",
                                                text: "You have to register first, before you can shop, if you already have an account, please log in to start shopping",
                                                position: "center",
                                                showCloseButton: true,
                                            })
                                        }
                                    }}
                                    disabled={selectedColor == null || selectedSizePickUp == null || selectedWarehouse == null || selectedBarcodePickUp == null}
                                    loading={pickUpLoader}
                                    color='orange'
                                    icon="plus cart"
                                    content="Add to Cart"
                                />
                            </Modal.Footer>
                        </Modal>
                        <Helmet>
                            <script>
                                {`
                                fbq("track", "ViewContent", {
                                    content_ids: '${dataPage?.id_product}',
                                    content_name: '${dataPage?.product_name}',
                                    content_category: '${dataPage?.category_name[0]}',
                                    content_type: 'product_group',
                                    value: '${dataPage?.final_price}', 
                                    currency: 'IDR'
                                });
                            `}
                            </script>
                        </Helmet>
                        <Row className='d-flex justify-content-start'>
                            <Col xl={6} lg={8} md={12} className='text-start'>
                                <Breadcrumb size='tiny'>
                                    <BreadcrumbSection link>HOME</BreadcrumbSection>
                                    <BreadcrumbDivider />
                                    {dataPage?.categories?.map((cat, i) => (
                                        <>
                                            <BreadcrumbSection onClick={() => handleRouteToCat(cat)}>{cat.name}</BreadcrumbSection>
                                            <BreadcrumbDivider />
                                        </>
                                    ))
                                    }
                                    <BreadcrumbSection active>{dataPage?.product_name}</BreadcrumbSection>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className={windowWidth < 600 ? 'pt-1' : 'pt-1'} style={bodyStyle}>
                            <Col xs={12} sm={12} md={5} lg={5} className={windowWidth < 600 ? 'pe-2 pt-1' : 'pe-5 pt-4'}>
                                <Row className='mb-4'>
                                    <ImageMain src={typeof defaultImage != 'undefined' ? defaultImage : 'https://via.placeholder.com/500x400.png'} />
                                </Row>
                                <Row>
                                    <ImageChild src={productImage} />
                                </Row>
                            </Col>
                            <Col md={6} lg={7} className='ps-3 pt-4'>
                                <Row className='mb-2'>
                                    <Col md={12} lg={12}>
                                        <Row>
                                            <Col xs={9} sm={9} md={9} lg={9}>
                                                <h1 className='text-start fs-5 fw-bold'>{dataPage?.product_name}</h1>
                                            </Col>
                                            <Col xs={3} sm={3} md={3} lg={3} className="text-end">
                                                {
                                                    (idCustomer) &&
                                                        (dataPage?.discount_flag == "FS") ? <></> :
                                                        (!dataPage?.is_wishlist) ?
                                                            <Popup content="Add to wishlist" trigger={<Button basic icon="heart outline" onClick={() => handleClickWishlist(idCustomer, dataPage?.id_product, dataPage?.id_category)} />} />
                                                            : <Label icon='like' style={{ color: '#FF5733' }} content="Wishlisted" basic />
                                                }
                                            </Col>
                                        </Row>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} lg={12} className="text-start">
                                        <h2 className='fs-6'>
                                            <span className='pe-3'>{Array.isArray(dataPage?.category_name) ? dataPage?.category_name.length > 1 ? dataPage?.category_name.map(o => o + ', ') : dataPage?.category_name : dataPage?.category_name}</span>
                                            <span className='me-3'><Label size="small">{dataPage?.segment_name}</Label></span>
                                            <span className='me-3'><Label size="small">{dataPage?.id_product}</Label></span>
                                            {pickedProduct.qty <= 0 ? <span className='me-3'><Label as="a" tag size='small' color="orange">Soldout</Label></span> : <></>}
                                        </h2>
                                    </Col>
                                </Row>
                                <Row className='pt-1'>
                                    <Col md={12} lg={12}>
                                        <h3 className='text-start fs-6 fw-light'>{dataPage?.product_desc}</h3>
                                    </Col>
                                </Row>
                                <Row className='pt-3'>
                                    <Col className='text-start'>
                                        <h2>
                                            <span className='text-start fs-5 fw-semibold me-3'>{global.IDR.format(dataPage?.final_price)}</span>
                                            <span className='text-start fs-5 fw-light text-muted'>{previousPriceCoret(dataPage)}</span>
                                        </h2>
                                    </Col>
                                </Row>
                                <Row className=''>
                                    <Col className='text-start mt-2 mb-1' >
                                        {
                                            discountLabel()
                                        }
                                        {/* <span className='text-muted'><small>Dsc. {formatNumberWithCommas(discountTotal)}</small></span> */}
                                    </Col>
                                </Row>
                                <Row className='d-flex justify-content-start'>
                                    <Col className='text-start mt-2' xl={4} lg={6} md={12} sm={12} xs={12}>
                                        {
                                            dataPage?.included_on_voucher &&
                                            dataPage?.included_on_voucher.map((item, i) => (
                                                item.type === 'D' ?
                                                    <Popup trigger={
                                                        <div key={i} className='fw-bold' style={{ color: '#F7634C' }}><Icon name='tag' />{item.name} -{item.type == 'D' ? item.percent : item.nominal}% off</div>
                                                    }
                                                        content={`This item is included in the voucher ${item.name}`}
                                                        size='mini'
                                                    />
                                                    :
                                                    <Popup trigger={
                                                        <div key={i} className='fw-bold' style={{ color: '#F7634C', fontSize: '0.9em' }}><Icon name='tag' />{item.name} {global.IDR.format(item.nominal)}</div>
                                                    }
                                                        content={`This item is included in the voucher ${item.name}`}
                                                        size='mini'
                                                    />
                                            ))
                                        }
                                    </Col>
                                </Row>
                                {/* <Row className='mt-3'>
                        <Col className='text-start' md={12} lg={12}>
                            <Stack direction='horizontal'>
                                <Label size='medium'>+{dataPage?.point} Point</Label>
                                <span className='text-muted ms-2'><small>You will get bonus points if you pay for this product</small></span>
                            </Stack>
                        </Col>
                    </Row> */}
                                <Row className='mt-4 text-start'>
                                    <div className='mb-1'>Size Group: {(dataPage?.size_group) ? <span className='fw-bold'>{dataPage?.size_group}</span> : <span className='text-muted'>not set</span>}</div>
                                    <label>Size: {(selectedSize) ? <span className='fw-bold'>{selectedSize}</span> : <span className='text-muted'>not selected</span>}</label>
                                    {
                                        windowWidth < 992 ?
                                            sortDataSizeGroup.map((group, i) => {
                                                return (
                                                    <Col className='text-start mt-2' sx={12} sm={12} md={12} lg={12}>
                                                        <Button.Group key={i}>
                                                            {
                                                                group.map((item, g) => (
                                                                    // <Button
                                                                    //     value={item.size}
                                                                    //     onClick={e => handleClickSize(e.target.value)}
                                                                    //     key={g}
                                                                    //     className={(selectedSize == item.size) ? 'active' : ''}
                                                                    //     disabled={(item.qty <= 0 ? true : false)}
                                                                    // >
                                                                    //     {item.size}
                                                                    // </Button>
                                                                    <Popup
                                                                        content={(Array.isArray(hasSizeObject.selected) && hasSizeObject.selected.includes(item.size)) || (item.has_item) ? "Already in your cart"
                                                                            // : "It will be available soon!"
                                                                            : "Unavailable"
                                                                        }
                                                                        disabled={!(item.qty <= 0) && !(item.has_item) && !(Array.isArray(hasSizeObject.selected) && hasSizeObject.selected.includes(item.size))}
                                                                        position='top left'
                                                                        on='click'
                                                                        inverted
                                                                        trigger={
                                                                            <span style={{
                                                                                display: 'inline-block',
                                                                                width: 55,
                                                                                height: 40,
                                                                                padding: 0,
                                                                                margin: 0,
                                                                                borderRadius: 0,
                                                                                lineHeight: 0, // collapse line height
                                                                                overflow: 'hidden'
                                                                            }}
                                                                            >
                                                                                <Button
                                                                                    value={item.size}
                                                                                    onClick={e => {
                                                                                        if (!(item.qty <= 0)) {
                                                                                            handleClickSize(e.target.value);
                                                                                        }
                                                                                    }}
                                                                                    content={item.size}
                                                                                    color={selectedSize === item.size ? 'orange' : ''}
                                                                                    className={`square-button ${(selectedSize === item.size)} ? 'active' : ''`}
                                                                                    disabled={(item.qty <= 0) || (item.has_item) || (Array.isArray(hasSizeObject.selected) && hasSizeObject.selected.includes(item.size)) || atcLoad || coLoad || pickUpLoader}
                                                                                />
                                                                            </span>
                                                                        }
                                                                    />
                                                                ))
                                                            }
                                                        </Button.Group>
                                                    </Col>
                                                )
                                            })
                                            :
                                            // <Col className='text-start mt-2' sx={12} sm={12} md={12} lg={12}>
                                            //     <Button.Group>
                                            //         {
                                            //             sortDataSize.map((item, i) => (
                                            //                 <Button
                                            //                     value={item.size}
                                            //                     onClick={e => handleClickSize(e.target.value)}
                                            //                     key={i}
                                            //                     className={(selectedSize == item.size) ? 'active' : ''}
                                            //                     disabled={(item.qty <= 0 ? true : false)}
                                            //                 >
                                            //                     {item.size}
                                            //                 </Button>

                                            //             ))
                                            //         }
                                            //     </Button.Group>
                                            // </Col>
                                            // <Col className='text-start mt-2' xs={12}>
                                            //     <Row>
                                            //         {
                                            //             sortDataSize.map((item, i) => (
                                            //                 <Col xs={2} sm={2} md={2} lg={2} key={i} className="mb-2">
                                            //                     <Button
                                            //                         value={item.size}
                                            //                         onClick={e => handleClickSize(e.target.value)}
                                            //                         className={(selectedSize == item.size) ? 'active w-100' : 'w-100'}
                                            //                         disabled={item.qty <= 0}
                                            //                     >
                                            //                         {item.size}
                                            //                     </Button>
                                            //                 </Col>
                                            //             ))
                                            //         }
                                            //     </Row>
                                            // </Col>
                                            <Col className='text-start mt-2' sx={12} sm={12} md={12} lg={12}>
                                                <Row>
                                                    {sortDataSize.map((item, i) => {
                                                        const isOutOfStock = item.qty <= 0;
                                                        const hasSize = item.has_item
                                                        const hasSizeClick = Array.isArray(hasSizeObject.selected) && hasSizeObject.selected.includes(item.size)
                                                        return (
                                                            <Col xs={2} sm={2} md={2} lg={2} key={i} className="mb-2">
                                                                <Popup
                                                                    content={
                                                                        hasSize || hasSizeClick
                                                                            ? "This size is already set in your cart"
                                                                            // : "This size will be available soon in the Online Store. Please check back later or see if it's available for Pick Up in Store!"
                                                                            : "Unavailable"
                                                                    }
                                                                    disabled={!isOutOfStock && !hasSize && !hasSizeClick}
                                                                    position="top left"
                                                                    on={windowWidth < 600 ? 'click' : 'hover'}
                                                                    inverted
                                                                    trigger={
                                                                        <div>
                                                                            <Button
                                                                                value={item.size}
                                                                                onClick={(e) => {
                                                                                    if (!(item.qty <= 0)) {
                                                                                        handleClickSize(e.target.value);
                                                                                    }
                                                                                }}
                                                                                className={(selectedSize === item.size) && (!hasSize || !hasSizeClick) ? 'active orange w-100' : 'w-100'}
                                                                                disabled={isOutOfStock || item.has_item || hasSizeClick || atcLoad || coLoad || pickUpLoader}
                                                                            >
                                                                                {item.size}
                                                                            </Button>
                                                                        </div>
                                                                    }
                                                                />
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                            </Col>

                                    }
                                    <Col className='text-start mt-2 mb-4' md={12} lg={12}>
                                        {
                                            // dataPage?.qty > 0 ?
                                            sizeQty == 1 ? <div className='text-danger'><Icon name='exclamation' />Only 1 left</div> : <><Icon name='check circle outline' /> Available</>
                                            // :
                                            // <></>
                                        }
                                    </Col>
                                    <Col className='text-start mt-1' md={12} lg={12}>
                                        <Button content="Size Guide" color='black' icon="external alternate" basic size='tiny' labelPosition='right' onClick={() => navigate('/home/sizeGuide')} />
                                    </Col>
                                </Row>
                                <Row className='mt-3 text-start'>
                                    <label>Color variation : &nbsp;&nbsp;{
                                        (selectedColor) ?
                                            <span>
                                                <canvas width={10} height={10} style={{ backgroundColor: selectedColor.color_main }} key={1} />
                                                <canvas width={10} height={10} style={{ backgroundColor: selectedColor.color_secondary }} key={2} />
                                                <canvas width={10} height={10} style={{ backgroundColor: selectedColor.color_accent }} key={3} />
                                            </span>
                                            :
                                            // dataPage?.qty > 0 ?
                                            <span className='text-muted'>not selected</span>
                                        // : <span className='text-muted'>not available</span>
                                    }</label>
                                    <Col className='text-start mt-2'>
                                        {
                                            // dataPage?.qty > 0 ?
                                            <Button.Group>
                                                {
                                                    dataPage?.color.map((item, i) => (
                                                        <Button
                                                            value={item.id_color}
                                                            onClick={(e) => {
                                                                setSelectedColorId(e.target.value)
                                                                setSelectedColor(item)
                                                            }}
                                                            key={i}
                                                            className={(selectedColorId == item.id_color) ? 'active' : ''}
                                                        >
                                                            {
                                                                <section
                                                                    style={{
                                                                        paddingLeft: 4,
                                                                        paddingRight: 4,
                                                                        paddingTop: 2,
                                                                        paddingBottom: 1,
                                                                        background: "whitesmoke",
                                                                        zIndex: 1
                                                                    }}
                                                                >
                                                                    <canvas
                                                                        width={10}
                                                                        height={10}
                                                                        style={{ backgroundColor: item.color_main }}
                                                                        key={1}
                                                                    ></canvas>
                                                                    <canvas
                                                                        width={10}
                                                                        height={10}
                                                                        style={{ backgroundColor: item.color_secondary }}
                                                                        key={2}
                                                                    ></canvas>
                                                                    <canvas
                                                                        width={10}
                                                                        height={10}
                                                                        style={{ backgroundColor: item.color_accent }}
                                                                        key={3}
                                                                    ></canvas>
                                                                </section>
                                                            }
                                                        </Button>
                                                    ))
                                                }
                                            </Button.Group>
                                            // :
                                            // <></>
                                        }
                                    </Col>
                                </Row>
                                <Row className='mt-5 text-start'>
                                    <Col sx={10} sm={12} md={12} lg={6}>
                                        {
                                            // dataPage?.qty > 0 ?
                                            <Button.Group fluid size={windowWidth < 600 ? 'small' : 'big'}>
                                                <Button
                                                    loading={atcLoad}
                                                    disabled={atcLoad || coLoad || pickUpLoader}
                                                    color='black'
                                                    icon="plus cart"
                                                    labelPosition='left'
                                                    content="Add to Cart"
                                                    onClick={() => {
                                                        if (ses.getItem('loginData')) {
                                                            if (isOrdered == 0 && isOrdered !== null) {
                                                                if (isPickUp != 0 && isPickUp !== null) {
                                                                    // if (selectedColorId == null) {
                                                                    Toast.fire({
                                                                        ////timer: 6000,
                                                                        icon: 'warning',
                                                                        text: 'Your cart has been set as Pick Up in Store Order. Please remove all item in cart first then try again!',
                                                                        position: 'center',
                                                                        showCloseButton: true
                                                                    })
                                                                } else if (selectedColor == null) {
                                                                    // if (selectedColorId == null) {
                                                                    Toast.fire({
                                                                        icon: 'warning',
                                                                        text: 'Color cannot be empty',
                                                                        position: 'center',
                                                                        showCloseButton: true,
                                                                    })
                                                                } else if (selectedSize == null) {
                                                                    Toast.fire({
                                                                        icon: 'warning',
                                                                        text: 'Size cannot be empty',
                                                                        position: 'center',
                                                                        showCloseButton: true,
                                                                    })
                                                                } else {
                                                                    pickedProduct(slcProduct(selectedColor, selectedSize))
                                                                    addProductCart('atc')
                                                                    setIsPickUp("0")
                                                                    if (isPickUp === null) {
                                                                        updatePickUp(false)
                                                                    }
                                                                }
                                                            } else if (isOrdered == 1) {
                                                                Toast.fire({
                                                                    icon: 'warning',
                                                                    text: 'There`s pending Order',
                                                                    position: 'center',
                                                                    showCloseButton: true
                                                                })
                                                                navigate('/cart/checkout')
                                                            } else if (isOrdered == 2) {
                                                                Toast.fire({
                                                                    icon: 'warning',
                                                                    text: 'There`s pending Payment',
                                                                    position: 'center',
                                                                    showCloseButton: true,
                                                                })
                                                                navigate('/cart/checkout/payment')
                                                            } else if (isOrdered == 3) {
                                                                Toast.fire({
                                                                    icon: 'warning',
                                                                    text: 'There`s pending Payment',
                                                                    position: 'center',
                                                                    showCloseButton: true,
                                                                })
                                                                navigate('/cart/checkout/paymentSnap')
                                                            }
                                                        } else {
                                                            Toast.fire({
                                                                icon: "warning",
                                                                text: "You have to register first, before you can shop, if you already have an account, please log in to start shopping",
                                                                position: "center",
                                                                showCloseButton: true,
                                                            })
                                                        }
                                                    }}
                                                />
                                                <Button.Or />
                                                <Button
                                                    loading={coLoad}
                                                    disabled={coLoad || atcLoad || pickUpLoader}
                                                    color='orange'
                                                    content="Checkout"
                                                    labelPosition='right'
                                                    icon="arrow alternate circle right outline"
                                                    onClick={() => {
                                                        if (ses.getItem('loginData')) {
                                                            if (isOrdered == 0 && isOrdered !== null) {
                                                                if (isPickUp != 0 && isPickUp !== null) {
                                                                    // if (selectedColorId == null) {
                                                                    Toast.fire({
                                                                        //timer: 6000,
                                                                        icon: 'warning',
                                                                        text: 'Your cart has been set as Pick Up in Store Order. Please remove all item in cart first then try again!',
                                                                        position: 'center',
                                                                        showCloseButton: true
                                                                    })
                                                                } else if (selectedColor == null) {
                                                                    // if (selectedColorId == null) {
                                                                    Toast.fire({
                                                                        icon: 'warning',
                                                                        text: 'Color cannot be empty',
                                                                        position: 'center',
                                                                        showCloseButton: true,
                                                                    })
                                                                } else if (selectedSize == null) {
                                                                    Toast.fire({
                                                                        showCloseButton: true,
                                                                        icon: 'warning',
                                                                        text: 'Size cannot be empty',
                                                                        position: 'center'
                                                                    })
                                                                } else {
                                                                    pickedProduct(slcProduct(selectedColor, selectedSize))
                                                                    addProductCart('co')
                                                                    setIsPickUp("0")
                                                                    if (isPickUp === null) {
                                                                        updatePickUp(false)
                                                                    }
                                                                }
                                                            } else if (isOrdered == 1) {
                                                                Toast.fire({
                                                                    icon: 'warning',
                                                                    text: 'There`s pending Order',
                                                                    position: 'center',
                                                                    showCloseButton: true,
                                                                })
                                                                navigate('/cart/checkout')
                                                            } else if (isOrdered == 2) {
                                                                Toast.fire({
                                                                    icon: 'warning',
                                                                    text: 'There`s pending Payment',
                                                                    position: 'center',
                                                                    showCloseButton: true,
                                                                })
                                                                navigate('/cart/checkout/payment')
                                                            } else if (isOrdered == 3) {
                                                                Toast.fire({
                                                                    icon: 'warning',
                                                                    text: 'There`s pending Payment',
                                                                    position: 'center',
                                                                    showCloseButton: true
                                                                })
                                                                navigate('/cart/checkout/paymentSnap')
                                                            }
                                                        } else {
                                                            Toast.fire({
                                                                //timer: 6000,
                                                                icon: "warning",
                                                                text: "You have to register first, before you can shop, if you already have an account, please log in to start shopping",
                                                                position: "center",
                                                                showCloseButton: true,
                                                            })
                                                        }
                                                    }}
                                                />
                                            </Button.Group>
                                            // :
                                            // <></>
                                        }
                                    </Col>
                                </Row>
                                {/* pickup in store */}
                                {/* <hr /> */}
                                <Row className='text-start'>
                                    <Col className='py-2' sx={10} sm={12} md={12} lg={12}>
                                        <hr
                                            style={{ width: getPickUpWidthStyle() }}
                                        />
                                        {
                                            !(dataPage?.isExcludeStore) ?
                                                <Button
                                                    fluid
                                                    size={windowWidth < 600 ? 'small' : 'big'}
                                                    loading={pickUpLoader}
                                                    disabled={pickUpLoader || atcLoad || coLoad}
                                                    style={{
                                                        width: getPickUpWidthStyle()
                                                    }}
                                                    color='orange'
                                                    basic
                                                    icon={<FontAwesomeIcon icon={faStore} className="me-2" />}
                                                    labelPosition='left'
                                                    content="Pick Up in Store"
                                                    onClick={() => {
                                                        if (selectedColor == null) {
                                                            Toast.fire({
                                                                icon: 'warning',
                                                                text: 'Color cannot be empty',
                                                                position: 'center',
                                                                showCloseButton: true,
                                                            })
                                                        } else {
                                                            showModalPickUp()
                                                        }
                                                    }}
                                                />
                                                :
                                                <>
                                                    <h5 className='text-center'
                                                        style=
                                                        {{
                                                            width: getPickUpWidthStyle()
                                                        }}
                                                    >
                                                        This Product is available on delivery order only
                                                    </h5>
                                                </>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='d-flex justify-content-center'>
                            <SuggestedProducts
                                idCategory={pickCategory}
                                exclude={excludeID}
                            />
                        </Row>
                    </Container>
                    :
                    <Container className='mt-5 mb-5 pt-5' fluid='sm' style={{ minHeight: '45vh', height: '100%' }}>
                        <div className='mt-5'>
                            <Icon name='warning circle' size='large' color='orange' className='mb-2' />
                            <div>{mssgTxt}</div>
                        </div>
                    </Container>
            }
        </>
    )

}

export default ProductPage;